/* @flow */

import * as React from 'react';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ElectroCheckbox from 'forms/components/inputs/ElectroCheckbox/ElectroCheckbox';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import type { TypeDisplayErrors } from 'forms/validation/Validator';
import styles from 'views/ActionDrawer/ActionDrawer.module.scss';
import type Form from 'forms/_.extend';

import AutoCompleteModel from 'models/forms/AutoCompleteModel.js';
import { autoCompleteCountries } from 'api/forms.js';

type TypeProps = {
  project: Object,
  form: Form,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewRoomForm extends React.Component<*> {
  // constructor(props: Object) {
  //     super(props);
  //     this.props.accountsModel.clear();
  //     this.props.companyModel.clear();
  //     this.props.companyModel.filterId = this.props.form.$('addSiteForm.tradingAccount').value;
  // }

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const form: Form = this.props.form;
    const parentForm: Object = this.props.parentForm;

    const countryModel: AutoCompleteModel = new AutoCompleteModel(autoCompleteCountries);
    countryModel.filterId = parentForm.$('location.locationCompany').extra.selectID;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock divider={false} gutters={true}>
            <div className={styles['form-group']}>
              <ElectroTextField field={form.$('addRoomForm.companyName')} />
              <ElectroTextField field={form.$('addRoomForm.site')} />
              <ElectroTextField field={form.$('addRoomForm.building')} />
              <ElectroTextField field={form.$('addRoomForm.roomName')} />
              <ElectroTextField field={form.$('addRoomForm.contactPhoneNo')} />
              <ElectroTextField field={form.$('addRoomForm.contactFaxNo')} />
              <ElectroTextField field={form.$('addRoomForm.locationContact')} />
            </div>
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.create')} />
      </React.Fragment>
    );
  }
}
